export const PROFILE_DATA = {
  name: "Nathaniel Faborada",
  nickname: "( Niel )",
  waveEmoji: "👋",
  avatarUrl: "https://res.cloudinary.com/diwwqfwjb/image/upload/v1781856471/709708660_122106236192438631_9022214745816065291_n_zbqziu.jpg",
  authorAvatarUrl: "https://res.cloudinary.com/diwwqfwjb/image/upload/v1776094289/542451323_122191510964372800_7390414124574237799_n_kg4uvt.jpg",
  bannerUrl: "https://res.cloudinary.com/diwwqfwjb/image/upload/v1776094457/HeaderCoverPortfolioImage_dkzcih.png",
  resumeUrl: "assets/Faborada_Nathaniel_Web_dev.pdf",
  bio: "Aspiring Junior software developer based in Pandi, Bulacan, specializing in React, Node.js, and REST API development. Builds clean, responsive applications with a focus on automation, and performance.",
  
  personalDetails: [
    { id: "location", text: "From Pandi, Bulacan", iconType: "location" },
    { id: "email", text: "faboradanathaniel@gmail.com", iconType: "email" },
    { id: "country", text: "Philippines", iconType: "country" },
    { id: "languages", text: "Filipino, English", iconType: "languages" },
  ],

  workExperience: [
    {
      company: "JCAS Logistics",
      roles: [
        { title: "Internship Developer", period: "April 2025 - May 2025" },
        { title: "Freelance Developer", period: "June 2025 - Sept 2025" },
      ],
    },
  ],

  learnedSkills: {
    description: "Technologies I use to build reliable, scalable products.",
    groups: [
      ["#javascript", "#react", "#html/css", "#flutterflow", "#tailwindcss"],
      ["#node.js", "#python", "#RESTful API", "#FastAPI", "#php", "#auth", "#express"],
      ["#postgresql", "#mysql", "#docker", "#github_actions"],
      ["#netlify", "#railway"],
      ["#gemini", "#chatgpt", "#claude"],
    ],
  },

  education: {
    institution: "College of Mary Immaculate of Pandi Bulacan Inc.",
    degree: "Bachelor of Science in Computer Science",
    period: "2022-2026",
  },

  socialLinks: [
    {
      platform: "github",
      label: "Github account",
      url: "https://github.com/nathanielfaborada",
    },
    {
      platform: "linkedin",
      label: "LinkedIn account",
      url: "https://www.linkedin.com/in/nathaniel-faborada/",
    },
  ],
};
